import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as Back } from "../../assets/svg/back.svg";
import { ReactComponent as WhatsApp } from "../../assets/svg/whatsapp.svg";
import { ReactComponent as Email } from "../../assets/svg/mail.svg";
import { ReactComponent as Link } from "../../assets/svg/link.svg";
import IconButton from "../IconButton";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useState } from "react";
import theme from "../theme";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.unit}px;

  > div {
    display: flex;
    align-items: center;
  }
`;
const Header = () => {
  const history = useHistory();
  const [copied, setCopied] = useState(false);
  return (
    <Wrapper>
      <IconButton onClick={() => history.goBack()}>
        <Back />
      </IconButton>
      <div>
        <IconButton
          href={`whatsapp://send?text=${window.location.href}`}
          data-action="share/whatsapp/share"
          onClick={(event) => event.preventDefault()}
        >
          <WhatsApp />
        </IconButton>
        <IconButton
          href={`mailto:info@mondialautomotive.nlbody=${window.location.href}`}
        >
          <Email />
        </IconButton>
        {!copied && (
          <CopyToClipboard
            text={window.location.href}
            onCopy={() => setCopied(true)}
          >
            <IconButton>
              <Link />
            </IconButton>
          </CopyToClipboard>
        )}
        {copied && <span>Link gekopieerd</span>}
      </div>
    </Wrapper>
  );
};

export default Header;
